import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import axios from 'axios';
import './Styles/ProductAddPage.scss';
import NewProductModal from './AddnewProduct.jsx';
import InfoModal from './InfoModal.jsx';

const ProductAddPage = () => {
    const [products, setProducts] = useState([]);
    const [newProductCode, setNewProductCode] = useState('');
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [isInfoModalOpen, setIsInfoModalOpen] = useState(false);
    const [errorMessage, setErrorMessage] = useState('');
    const [profile, setProfile] = useState(null);

    useEffect(() => {
        fetchData();
        fetchProfile();
    }, []);

    const fetchData = async () => {
        try {
            const token = localStorage.getItem('ownerToken');
            const config = {
                headers: { Authorization: `Bearer ${token}` }
            };
            const response = await axios.post(`${process.env.REACT_APP_BASE_URL}/api/products/addSaleX`, {}, config);
            setProducts(response.data.data);
        } catch (error) {
            console.error('Error fetching data:', error);
        }
    };

    const fetchProfile = async () => {
        try {
            const token = localStorage.getItem('ownerToken');
            const config = {
                headers: { Authorization: `Bearer ${token}` }
            };
            const response = await axios.get(`${process.env.REACT_APP_BASE_URL}/api/auth/profile`, config);
            setProfile(response.data.profile);
        } catch (error) {
            console.error('Error fetching profile:', error);
        }
    };

    const openModal = () => {
        setIsModalOpen(true);
    };

    const closeModal = () => {
        setIsModalOpen(false);
    };

    const openInfoModal = () => {
        setIsInfoModalOpen(true);
    };

    const closeInfoModal = () => {
        setIsInfoModalOpen(false);
    };

    const addProduct = async () => {
        try {
            const token = localStorage.getItem('ownerToken');
            const config = {
                headers: { Authorization: `Bearer ${token}` }
            };
    
            if (newProductCode.trim() !== "") {
                const code = newProductCode.trim();
    
                const response = await axios.post(`${process.env.REACT_APP_BASE_URL}/api/products/add`, {
                    productCode: code,
                }, config);
    
                setErrorMessage(response.data.message); // Use the response message
                setNewProductCode(''); // Clear input after adding
    
                // Fetch updated product list (Fixes count not updating issue)
                fetchData();
            } else {
                setErrorMessage('Product code cannot be empty.');
            }
        } catch (error) {
            if (error.response) {
                setErrorMessage(error.response.data.message);
            } else {
                setErrorMessage('Failed to add product. Please try again.');
            }
        }
    };
    

    return (
        <div>


            <div className="product-Add-Container">
                <nav className='centered-nav-Owner'>
                    <ul>
                        {profile && profile.mainOwner === 1 && (
                            <li>
                                <Link to={`/Owner-Home/Sale`} className="product-button">Product Sales</Link>
                            </li>
                        )}
                        <li>
                            <Link to="/Owner-Home" className="product-button">Home</Link>
                        </li>
                    </ul>
                </nav>
                <h2>Add Product</h2>
                <div className="buttons-container">
                    <button className="new-product-modal-button" onClick={openModal}>Add New Product</button>
                    <button className="info-modal-button" onClick={openInfoModal}>Info</button>
                </div>

                {isModalOpen && <NewProductModal closeModal={closeModal} />}
                {isInfoModalOpen && <InfoModal closeModal={closeInfoModal} />}
    {/* Product Code Input Row */}
                    <div className="product-input-row">
                    <label>Product Code:</label>
                    <input
                        type="text"
                        value={newProductCode}
                        onChange={(e) => setNewProductCode(e.target.value)}
                        placeholder="Enter product code"
                    />
                    <button onClick={addProduct}>Add Product</button>
                </div>
                <div className="error-message-container">
                    {errorMessage && <div className="error-message">{errorMessage}</div>}
                </div>

            </div>


            <div className="product-cards-containerAdd">
                {products.map((product, index) => (
                    product.productName && product.imageUrl ? (
                        <div className="product-card" key={`${product.productName}-${index}`}>
                            <img src={product.imageUrl} alt={product.productName} className="product-image" />
                            <div className="product-details">
                                <div className="product-nameAdd">{product.productName}</div>
                                <div className="product-sizeAdd">Size: {product.size}</div>
                                <div className="product-colorAdd">Color: {product.color}</div>
                                <div className="product-countAdd">Count: {product.status_0}</div>
                            </div>
                        </div>
                    ) : null
                ))}
            </div>
        </div>
    );
}

export default ProductAddPage;
